export var getIcons = function getIcons(category) {
  switch (category) {
    case 'fa':
      return function () {
        return import( /* webpackChunkName: "icons.fa" */
        'react-icons/fa');
      };
    case 'bs':
      return function () {
        return import( /* webpackChunkName: "icons.bs" */
        'react-icons/bs');
      };
    case 'io':
      return function () {
        return import( /* webpackChunkName: "icons.io" */
        'react-icons/io');
      };
    case 'md':
      return function () {
        return import( /* webpackChunkName: "icons.md" */
        'react-icons/md');
      };
    case 'ti':
      return function () {
        return import( /* webpackChunkName: "icons.ti" */
        'react-icons/ti');
      };
    case 'go':
      return function () {
        return import( /* webpackChunkName: "icons.go" */
        'react-icons/go');
      };
    case 'fi':
      return function () {
        return import( /* webpackChunkName: "icons.fi" */
        'react-icons/fi');
      };
    case 'gi':
      return function () {
        return import( /* webpackChunkName: "icons.gi" */
        'react-icons/gi');
      };
    case 'wi':
      return function () {
        return import( /* webpackChunkName: "icons.wi" */
        'react-icons/wi');
      };
    case 'di':
      return function () {
        return import( /* webpackChunkName: "icons.di" */
        'react-icons/di');
      };
    case 'ai':
      return function () {
        return import( /* webpackChunkName: "icons.ai" */
        'react-icons/ai');
      };
    default:
      return null;
  }
};